export default function Clock_Start() {
  return (
    <div>
      <h1>Clock_Start Component</h1>
    </div>
  );
}
